<template>
  <m-card
    :class="{ 'cursor-pointer': readOnly }"
    sr-label="View future action/recall"
    @click="futureActionOverview()"
  >
    <div
      :class="[
        {
          clickable: !readOnly,
          'marked-incorrect': entry.data.isMarkedIncorrect,
        },
      ]"
    >
      <m-layout-stack horizontal>
        <div class="flex-auto">
          <span v-if="entry.data.displayStatus === 'Planned'">
            <b>Future action/recall:</b> {{ entry.data.clinicalCode }} • Planned for
            {{ entry.data.plannedDateRange }}
          </span>
          <span v-else>
            <b>Future action/recall:</b> {{ entry.data.clinicalCode }} • Due
            {{ entry.data.plannedDateRange }}
          </span>
          <span
            v-if="
              entry.data.displayStatus === 'Completed' || entry.data.displayStatus === 'Cancelled'
            "
          >
            • {{ entry.data.displayStatus }}
          </span>
        </div>
        <i v-if="entry.data.isRetrospectivelyAmended" style="white-space: nowrap">{{
          formatRetrospectivelyAmendedLabel
        }}</i>
        <m-badge
          v-if="!entry.data.isMarkedIncorrect && entry.data.displayStatus === 'Overdue'"
          amber
          :text="entry.data.displayStatus"
        />
      </m-layout-stack>
      <div
        v-if="
          entry.data.hiddenFromPatientFacingServices ||
          entry.data.confidentialFromThirdParties ||
          entry.data.linkedProblems.length
        "
      >
        <span class="secondary-text">
          {{ getConfidentialityTextAndLinkedProblems() }}
        </span>
      </div>
      <m-separator v-if="entry.data.details" class="q-my-xs" />
      <span v-if="entry.data.details">
        {{ entry.data.details }}
      </span>
    </div>
  </m-card>
</template>

<script setup lang="ts">
import { openSlideover } from "../../../../composables/dialog/drawer";
import { PatientJournalRecord } from "../types";
import MSeparator from "../../MSeparator";
import { computed } from "vue";

const props = defineProps<{
  entry: PatientJournalRecord;
  readOnly: boolean;
  clickable?: boolean;
}>();

function futureActionOverview() {
  return props.readOnly
    ? openSlideover(`/future-action/patient-overview/${props.entry.id}`, { close: true })
    : undefined;
}

function getConfidentialityTextAndLinkedProblems() {
  const textArray = [];

  if (props.entry.data.hiddenFromPatientFacingServices) {
    textArray.push("Redacted from Patient Online Access");
  }
  if (props.entry.data.confidentialFromThirdParties) {
    textArray.push("Confidential from Third Parties");
  }

  const text = textArray.join(" • ");

  const problemsArray = props.entry.data.linkedProblems || [];
  const problemDescriptions = problemsArray
    .filter((x) => x.problemCodeDescription)
    .map((x) => x.problemCodeDescription);

  const problemText = problemDescriptions.length
    ? `Linked Problems: ${problemDescriptions.join(", ")}`
    : "";

  const finalTextArray = [text, problemText].filter(Boolean);

  return finalTextArray.length ? finalTextArray.join(" • ") : false;
}

const formatRetrospectivelyAmendedLabel = computed(() => {
  let label = [];
  if (props.entry.data.isRetrospectivelyAmended) {
    label.push("Edited");
  }

  return label.join(" • ");
});
</script>
